
function parseWithLocalTime(date) {
  var dateParts = date.split('/');
  return new Date(dateParts[2], dateParts[0]-1, dateParts[1]).getTime();
}

function getUTCTime(date) {
  if (typeof date == 'string') {
    var dateParts = date.split('/');
    return Date.UTC(dateParts[2], dateParts[0]-1, dateParts[1])
  } else {
    var month = date.getMonth();
    var year = date.getFullYear();
    return Date.UTC(year, month, date.getDate())
  }
}


function uuidv4() {
  /*eslint no-mixed-operators: "error"*/
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = (c === 'x' ? r : ((r & 0x3) | 0x8));
    return v.toString(16);
  });
}


export default {
  parseWithLocalTime,
  getUTCTime,
  uuidv4
};